<template>
  <el-dialog :title="ModalTitle" v-model="shouldShow" width="80%">
    <form @submit.prevent="save">
      <el-descriptions class="label-form-descriptions" :column="12" border>
        <el-descriptions-item label="Nome" :span="6">
          <el-input
            v-model="label_.name"
            placeholder="Insira o nome da etiqueta"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="Grupo" :span="3">
          <el-select
            v-model="label_.group"
            filterable
            allow-create
            clearable
            default-first-option
            :loading="isLoadingLabelGroups"
            placeholder="Selecione ou crie"
            @visible-change="fetchLabelGroups"
            @change="normalizeLabelGroup"
          >
            <el-option
              v-for="group in labelGroups"
              :key="group"
              :label="group"
              :value="group"
            ></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="Descrição" :span="3">
          <el-input
            v-model="label_.description"
            placeholder="Descrição opcional"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="Embalagem" :span="3">
          <el-input
            v-model="label_.packing"
            placeholder="Ex.: pacote"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="Resfriamento ou congelamento" :span="3">
          <el-select
            v-model="label_.temperature_type"
            clearable
            placeholder="Selecione"
          >
            <el-option label="Resfriado" value="Resfriado"></el-option>
            <el-option label="Congelado" value="Congelado"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="Dias de vencimento" :span="3">
          <el-input
            v-model="label_.expiration_days"
            type="number"
            min="0"
            placeholder="Ex.: 30"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="Tipo de embalagem" :span="3">
          <el-input
            v-model="label_.packing_type"
            placeholder="Ex.: vácuo"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="Orientação" :span="3">
          <el-select
            v-model="label_.orientation"
            placeholder="Selecione"
          >
            <el-option label="Retrato" value="portrait"></el-option>
            <el-option label="Paisagem" value="landscape"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="Largura do papel" :span="3">
          <el-input
            v-model="label_.paper_width"
            type="number"
            min="1"
            placeholder="Ex.: 102"
          >
            <template #append>mm</template>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item label="Tipo de impressão" :span="12">
          <el-radio-group v-model="printContext" @change="changePrintContext">
            <el-radio-button label="product">Produto</el-radio-button>
            <el-radio-button label="order_product">
              Produto no pedido
            </el-radio-button>
          </el-radio-group>
        </el-descriptions-item>
      </el-descriptions>

      <el-tabs v-model="activeTab" class="label-tabs">
        <el-tab-pane label="Template" name="template">
          <label-rich-text-editor
            ref="templateEditor"
            v-model="label_.template"
            :variable-groups="variableGroups"
          ></label-rich-text-editor>
        </el-tab-pane>
        <el-tab-pane label="Preview" name="preview">
          <label class="field-label">Pré-visualização:</label>
          <el-row :gutter="8">
            <el-col v-if="IsOrderProductPrint" :md="12" :xs="24">
              <el-select
                v-model="selectedOrderUid"
                filterable
                remote
                clearable
                reserve-keyword
                placeholder="Pedido"
                :remote-method="fetchOrders"
                :loading="isLoadingOrders"
                @change="selectOrder"
              >
                <el-option
                  v-for="order in orders"
                  :key="order.uid"
                  :label="OrderLabel(order)"
                  :value="order.uid"
                ></el-option>
              </el-select>
            </el-col>
            <el-col v-if="IsOrderProductPrint" :md="12" :xs="24">
              <el-select
                v-model="selectedOrderProductUid"
                filterable
                clearable
                placeholder="Produto do pedido"
                :disabled="!selectedOrder"
                @change="selectOrderProduct"
              >
                <el-option
                  v-for="product in OrderProducts"
                  :key="product.uid"
                  :label="OrderProductLabel(product)"
                  :value="product.uid"
                ></el-option>
              </el-select>
            </el-col>
            <el-col v-if="IsProductPrint" :md="12" :xs="24">
              <el-select
                v-model="selectedProductUid"
                filterable
                remote
                clearable
                reserve-keyword
                placeholder="Produto"
                :remote-method="fetchProducts"
                :loading="isLoadingProducts"
                @change="selectProduct"
              >
                <el-option
                  v-for="product in products"
                  :key="product.uid"
                  :label="product.name"
                  :value="product.uid"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :md="12" :xs="24">
              <el-select v-model="storageType" placeholder="Armazenamento">
                <el-option
                  v-for="option in storageOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <div class="label-preview" v-html="PreviewHtml"></div>
        </el-tab-pane>
      </el-tabs>
    </form>

    <template #footer>
      <el-row justify="space-between" type="flex">
        <el-button type="text" class="button" @click="shouldShow = false">
          Cancelar
        </el-button>
        <el-button
          type="text"
          class="button"
          :loading="isLoadingSave"
          @click="save"
        >
          Salvar
        </el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import LabelRichTextEditor from "../../components/labels/LabelRichTextEditor.vue";
import LabelService from "../../services/labels.js";
import OrderService from "../../services/orders.js";
import ProductService from "../../services/products.js";
import {
  LABEL_PRINT_CONTEXTS,
  LABEL_STORAGE_OPTIONS,
  LABEL_STORAGE_TYPES,
  buildMountedProducts,
  buildTemplateContext,
  getPartnerName,
  getLabelVariableGroups,
  interpolateTemplate,
} from "../../utils/labels.js";

export default {
  name: "LabelModal",
  components: { LabelRichTextEditor },
  props: ["label", "showModal"],
  emits: ["close-modal", "should-update"],
  data() {
    return {
      label_: { ...(this.label || {}) },
      activeTab: "template",
      orders: [],
      products: [],
      labelGroups: [],
      selectedOrderUid: null,
      selectedProductUid: null,
      selectedOrderProductUid: null,
      selectedOrder: null,
      selectedOrderProduct: null,
      selectedProduct: null,
      printContext: LABEL_PRINT_CONTEXTS.PRODUCT,
      storageType: LABEL_STORAGE_TYPES.CHILLED,
      isLoadingOrders: false,
      isLoadingProducts: false,
      isLoadingLabelGroups: false,
      isLoadingSave: false,
    };
  },
  computed: {
    ModalTitle() {
      return this.IsNew ? "Cadastrar Etiqueta" : "Editar Etiqueta";
    },
    IsNew() {
      return !this.label;
    },
    IsProductPrint() {
      return this.printContext === LABEL_PRINT_CONTEXTS.PRODUCT;
    },
    IsOrderProductPrint() {
      return this.printContext === LABEL_PRINT_CONTEXTS.ORDER_PRODUCT;
    },
    variableGroups() {
      return getLabelVariableGroups(this.printContext);
    },
    storageOptions() {
      return LABEL_STORAGE_OPTIONS;
    },
    PreviewHtml() {
      return interpolateTemplate(
        this.label_.template,
        buildTemplateContext({
          label: this.label_,
          order: this.IsOrderProductPrint ? this.SelectedOrderForPreview : null,
          product: this.IsProductPrint ? this.selectedProduct : null,
          printContext: this.printContext,
          storageType: this.storageType,
          metadata: {
            printed_by: this.$store.state.user?.name || "Usuário",
            printed_at: "01/01/2026 08:00",
            manufactured_at: "01/01/2026",
            production_id: "123",
            copies: 1,
            weight:
              this.selectedOrderProduct?.weight ||
              this.selectedProduct?.weight ||
              "1.000",
          },
        })
      );
    },
    OrderProducts() {
      return this.selectedOrder?.products || [];
    },
    SelectedOrderForPreview() {
      if (!this.selectedOrder || !this.selectedOrderProduct)
        return this.selectedOrder;

      return {
        ...this.selectedOrder,
        products: [this.selectedOrderProduct],
      };
    },
    shouldShow: {
      get() {
        return this.showModal;
      },
      set() {
        this.$emit("close-modal");
      },
    },
  },
  watch: {
    label(v) {
      this.label_ = {
        orientation: "portrait",
        paper_width: 102,
        ...(v || {}),
      };
    },
    showModal(v) {
      if (v) {
        this.label_ = {
          orientation: "portrait",
          paper_width: 102,
          ...(this.label || {}),
        };
        this.printContext = LABEL_PRINT_CONTEXTS.PRODUCT;
        this.storageType = LABEL_STORAGE_TYPES.CHILLED;
        this.changePrintContext();
        this.fetchLabelGroups();
      }
    },
  },
  methods: {
    normalizeGroup(group) {
      const normalizedGroup = String(group || "").trim().toUpperCase();

      return normalizedGroup || null;
    },
    normalizeLabelGroup() {
      this.label_.group = this.normalizeGroup(this.label_.group);
    },
    async fetchLabelGroups(visible = true) {
      if (!visible || this.isLoadingLabelGroups) return;

      this.isLoadingLabelGroups = true;
      const { groups, error } = await LabelService().groups();

      if (groups) this.labelGroups = groups;
      else
        this.$notify({
          title: "Não foi possível carregar os grupos de etiquetas",
          message: error?.message,
          type: "error",
          position: "bottom-right",
        });

      this.isLoadingLabelGroups = false;
    },
    changePrintContext() {
      this.selectedOrderUid = null;
      this.selectedProductUid = null;
      this.selectedOrderProductUid = null;
      this.selectedOrder = null;
      this.selectedOrderProduct = null;
      this.selectedProduct = null;

      if (this.IsOrderProductPrint) this.fetchOrders("");
      else this.fetchProducts("");
    },
    OrderLabel(order) {
      return `#${order.code || order.uid} ${getPartnerName(order.client)}`;
    },
    OrderProductLabel(product) {
      return product?.product?.name || product?.mounted?.product?.name || product.uid;
    },
    async fetchOrders(query) {
      this.isLoadingOrders = true;
      const filters = { limit: 30, include_product_mounted: true };

      if (query && Number(query)) filters.code = query;
      else if (query) filters.searchName = query;

      const { orders } = await OrderService().index(filters);
      this.orders = orders?.data || orders || [];
      this.isLoadingOrders = false;
    },
    async fetchProducts(query) {
      this.isLoadingProducts = true;
      const { products } = await ProductService().index({
        searchName: query,
        is_normal_sell_available: true,
      });
      this.products = buildMountedProducts(products || [], true);
      this.isLoadingProducts = false;
    },
    async selectOrder(uid) {
      if (!uid) {
        this.selectedOrder = null;
        this.selectedOrderProduct = null;
        this.selectedOrderProductUid = null;
        return;
      }

      this.isLoadingOrders = true;
      const { order } = await OrderService(uid).get();
      this.selectedOrder = order || this.orders.find((order) => order.uid === uid);
      this.selectedOrderProduct = null;
      this.selectedOrderProductUid = null;

      if (this.OrderProducts.length === 1) {
        this.selectedOrderProduct = this.OrderProducts[0];
        this.selectedOrderProductUid = this.selectedOrderProduct.uid;
      }

      this.isLoadingOrders = false;
    },
    selectOrderProduct(uid) {
      if (!uid) {
        this.selectedOrderProduct = null;
        return;
      }

      this.selectedOrderProduct = this.OrderProducts.find(
        (product) => product.uid === uid
      );
    },
    selectProduct(uid) {
      if (!uid) {
        this.selectedProduct = null;
        return;
      }

      this.selectedProduct = this.products.find((product) => product.uid === uid);
    },
    save() {
      this.$refs.templateEditor?.syncContent();
      this.normalizeLabelGroup();

      if (!this.label_.name || !this.label_.template) {
        this.$notify({
          title: "Informe nome e template da etiqueta",
          type: "error",
          position: "bottom-right",
        });
        return;
      }

      return this.IsNew ? this.createLabel() : this.updateLabel();
    },
    async createLabel() {
      this.isLoadingSave = true;
      const { label, error } = await LabelService().create(this.label_);

      this.afterSave(label, error, "cadastrar");
    },
    async updateLabel() {
      this.isLoadingSave = true;
      const { label, error } = await LabelService(this.label_.uid).update(
        this.label_
      );

      this.afterSave(label, error, "atualizar");
    },
    afterSave(label, error, action) {
      if (label) {
        this.$emit("should-update");
        this.$emit("close-modal");
        this.label_ = {};
        this.$notify({
          title: label.message,
          type: "success",
          position: "bottom-right",
        });
      } else
        this.$notify({
          title: `Ocorreu um erro ao ${action} etiqueta`,
          message: error?.message,
          type: "error",
          position: "bottom-right",
        });

      this.isLoadingSave = false;
    },
  },
};
</script>

<style scoped>
.field-label {
  display: block;
  margin: 16px 0 6px;
  font-size: 13px;
  font-weight: 600;
}

.label-tabs {
  margin-top: 16px;
}

.label-preview {
  min-height: 320px;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: auto;
}

.label-preview {
  background: #fafafa;
}

.label-form-descriptions {
  margin-bottom: 8px;
}

:deep(.label-form-descriptions .el-descriptions__label) {
  width: 155px;
  color: #606266;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

:deep(.label-form-descriptions .el-descriptions__content) {
  padding: 8px 10px;
}

:deep(.label-form-descriptions .el-input),
:deep(.label-form-descriptions .el-select),
:deep(.label-form-descriptions .el-radio-group) {
  width: 100%;
}

:deep(.label-form-descriptions .el-input__inner) {
  height: 38px;
  line-height: 38px;
}

.el-select {
  width: 100%;
  margin-bottom: 8px;
}

:deep(.label-form-descriptions .el-select) {
  margin-bottom: 0;
}
</style>
